<button
  type="button"
  class="expansion-panel__header"
  [class.expanded]="expanded()"
  [attr.aria-expanded]="expanded()"
  (click)="toggle()">
  <div class="expansion-panel__header-info">
    @if (icon(); as panelIcon) {
      <fa-duotone-icon [icon]="panelIcon"></fa-duotone-icon>
    }
    <ng-content select="[panel-title]"></ng-content>
  </div>
  <fa-duotone-icon
    [icon]="faChevronDown"
    class="expansion-panel__chevron"
    [class.rotated]="expanded()"></fa-duotone-icon>
</button>

@if (expanded()) {
  <div class="expansion-panel__body">
    <ng-content></ng-content>
  </div>
}
